import {
  STATUS_FAILURE,
  STATUS_PENDING,
  STATUS_SUCCESS,
} from "Common/constants/commonConstants";
import * as AdminPageConstants from "./AdminPageConstants";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
  rolesOfUser: [],
  fetchInstGroupsForMappingStatus: STATUS_SUCCESS,
  fetchInstGroupsForMappingErrMsg: "",
  instGroupsForMapping: [],
  fetchUserGroupsForMappingStatus: STATUS_SUCCESS,
  fetchUserGroupsForMappingErrMsg: "",
  userGroupsForMapping: [],
  maxInstrumentUnEnrollmentCount:0,
  isMaxCountFetching:false,
  maxCountFetched:false,
  maxCountFetchingFailed:false
};

export default function AdminPageReducer(state = initialState, action) {
  switch (action.type) {
    case AdminPageConstants.ROLES_OF_USER:
      return assign({}, state, {
        rolesOfUser: action.newState.rolesOfUser,
      });
      break;
    case AdminPageConstants.INST_GROUPS_FOR_MAPPING_REQUEST: {
      const newState = {
        ...state,
        fetchInstGroupsForMappingStatus: STATUS_PENDING,
        fetchInstGroupsForMappingErrMsg: "",
        instGroupsForMapping: [],
      };

      return assign({}, state, newState);
    }
    case AdminPageConstants.INST_GROUPS_FOR_MAPPING_SUCCESS: {
      const newState = {
        ...state,
        fetchInstGroupsForMappingStatus: STATUS_SUCCESS,
        instGroupsForMapping: [...action.payload],
      };

      return assign({}, state, newState);
    }
    case AdminPageConstants.INST_GROUPS_FOR_MAPPING_ERROR: {
      const newState = {
        ...state,
        fetchInstGroupsForMappingStatus: STATUS_FAILURE,
        fetchInstGroupsForMappingErrMsg:
          AdminPageConstants.GENERIC_ERROR_MESSAGE,
      };

      return assign({}, state, newState);
    }

    case AdminPageConstants.USER_GROUPS_FOR_MAPPING_REQUEST: {
      const newState = {
        ...state,
        fetchUserGroupsForMappingStatus: STATUS_PENDING,
        fetchUserGroupsForMappingErrMsg: "",
        userGroupsForMapping: [],
      };

      return assign({}, state, newState);
    }
    case AdminPageConstants.USER_GROUPS_FOR_MAPPING_SUCCESS: {
      const newState = {
        ...state,
        fetchUserGroupsForMappingStatus: STATUS_SUCCESS,
        userGroupsForMapping: [...action.payload],
      };

      return assign({}, state, newState);
    }
    case AdminPageConstants.USER_GROUPS_FOR_MAPPING_ERROR: {
      const newState = {
        ...state,
        fetchUserGroupsForMappingStatus: STATUS_FAILURE,
        fetchUserGroupsForMappingErrMsg:
          AdminPageConstants.GENERIC_ERROR_MESSAGE,
      };

      return assign({}, state, newState);
    }

    case AdminPageConstants.MAX_INSTRUMENT_UNENROLLMENT_COUNT_REQUEST:
      return assign({}, state, {
          
        maxInstrumentUnEnrollmentCount:0,
        isMaxCountFetching:true,
        maxCountFetched:false,
        maxCountFetchingFailed:false
      });

      case AdminPageConstants.MAX_INSTRUMENT_UNENROLLMENT_COUNT_SUCCESS:
      return assign({}, state, {
          
        maxInstrumentUnEnrollmentCount:action.payload.maxInsrumentUnenrollmentCount,
        isMaxCountFetching:false,
        maxCountFetched:true,
        maxCountFetchingFailed:false
      });

      case AdminPageConstants.MAX_INSTRUMENT_UNENROLLMENT_COUNT_ERROR:
        return assign({}, state, {
            
          maxInstrumentUnEnrollmentCount:0,
          isMaxCountFetching:false,
          maxCountFetched:false,
          maxCountFetchingFailed:true
        });
    default:
      return state;
  }
}
